import { Component, OnInit } from '@angular/core';
import { EstadisticasService } from '../../service/estadisticas.service';
import { NavigationEnd, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { CifrasMensualesService } from '../../service/cifras-mensuales.service';
import { SeoService } from '../../service/seo.service';
import { UrlcanonicaService } from '../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-estadisticas',
  templateUrl: './estadisticas.component.html',
  styleUrls: ['./estadisticas.component.css']
})
export class EstadisticasComponent implements OnInit{

  type: any;
  typecon: any;
  consultas: any;
  consultorios: any;
  cifra: any;
  
  RouteText : any;
  tituloseo: any;
  urlcanonicaseo: any;
  imagenseo: any;
  keywordsseo: any;
  descripcionseo: any;

  constructor(
    private meta: Meta,
    private title: Title,
    private _estadisticasService: EstadisticasService,
    private router: Router,
    private _cifrasMensualesService: CifrasMensualesService,
    private _seoService: SeoService,
    private _urlcanonicaservice: UrlcanonicaService
    
    ) { 
      
      this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        this.RouteText = event;
        this.getSEO(event.url)
      });
   
  }
  getConsultas() {
    this._estadisticasService.getEstadisticasConsultas().subscribe((resp: any) => {
      this.consultas = resp.reverse();
      this.type = "alert";

    });
  }

  getCifrasMensual() {
    this._cifrasMensualesService.getCifraAcumulada().subscribe((resp: any) => {
      this.cifra = resp.cantidad;
    });
  }

  getConsultorios() {
    this._estadisticasService.getEstadisticasConsultorios().subscribe((resp: any) => {
      console.log(resp)
      this.consultorios = resp.reverse();
      this.typecon = "danger";

    });
  }

  ngOnInit(): void {
    this.getConsultas();
    this.getConsultorios();
    this.getCifrasMensual();
  }

  go(){
    this.router.navigate(['consultas-por-estado']);
    }

    getSEO(page: string) {
      this._seoService.getSEO(page).subscribe((resp: any) => {
        console.log(resp)
        if (resp != null) {
          this.tituloseo = resp.titulo;
          this.descripcionseo = resp.descripcion;
          this.urlcanonicaseo = resp.urlcanonica;
          this.imagenseo = resp.imagen;
    
          this._urlcanonicaservice.createCanonicalLink();
          this.title.setTitle(this.tituloseo)
          this.meta.updateTag({
            name: 'description',
            content: this.descripcionseo
          })
    
          this.meta.updateTag({
            property: 'twitter:card',
            content: 'summary'
          })
          this.meta.updateTag({
            property: 'twitter:site',
            content: '@fundacionbest'
          })
          this.meta.updateTag({
            property: 'twitter:title',
            content: 'Fundación BEST'
          })
          this.meta.updateTag({
            property: 'twitter:description',
            content: this.descripcionseo
          })
          this.meta.updateTag({
            property: 'twitter:image',
            content: this.imagenseo
          })
    
          this.meta.updateTag({
            property: 'og:url',
            content: 'https://fundacionbest.org.mx/servicios'
          })
          this.meta.updateTag({
            property: 'og:title',
            content: this.tituloseo
          })
          this.meta.updateTag({
            property: 'og:image',
            content: this.imagenseo
          })
          this.meta.updateTag({
            property: 'og:description',
            content: this.descripcionseo
          })
        }
    
      });
    }


}

